/** Hidden Input **/

.checkboxField_input {
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  cursor: pointer;
  height: var(--checkbox-size);
  outline: none;
  position: relative;
  width: var(--checkbox-size);
  z-index: 1;
}

/*
 * Grows the hit area around the box. A pseudo-element rather than padding on
 * the input, so a touch-sized target doesn't push the label off the box.
 */
.checkboxField_input::before {
  content: '';
  height: var(--checkbox-tap-target);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--checkbox-tap-target);
}

.checkboxField_input:disabled {
  cursor: default;
}

.checkboxField_input:indeterminate,
.checkboxField_input:checked {
  background-color: transparent;
}

.checkboxField_input:focus-visible::after {
  border: 1px solid var(--colors-primary-main);
  bottom: -3px;
  background-color: transparent;
  content: '';
  border-radius: 7px;
  display: inherit;
  left: -3px;
  position: absolute;
  right: -3px;
  top: -3px;
}

/** Presentational Checkbox **/

.checkboxField_input ~ div[role='presentation'] {
  --checked-icon: ''; /* Required to pass stylelint check */
  --indeterminate-icon: ''; /* Required to pass stylelint check */

  border-radius: 4px;
  height: var(--checkbox-size);
  position: absolute;
  top: 0;
  width: var(--checkbox-size);
  background-color: var(--colors-grays-white);
  border: 2px solid var(--colors-grays-mid);
  box-shadow: var(--shadows-inner);
}

.checkboxField_input ~ div[role='presentation']::after {
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.checkboxField_input:checked ~ div[role='presentation']::after,
.checkboxField_input:indeterminate ~ div[role='presentation']::after {
  background-position: center;
  background-repeat: no-repeat;

  /* Resolves to the icons' intrinsic 16px at the default 24px box. */
  background-size: calc(var(--checkbox-size) * 2 / 3);
  border-radius: 4px;
  filter: brightness(100);
}

.checkboxField_input:checked ~ div[role='presentation']::after {
  background-image: var(--checked-icon);
}

.checkboxField_input:indeterminate ~ div[role='presentation']::after {
  background-image: var(--indeterminate-icon);
}

.checkboxField_input:checked ~ div[role='presentation'],
.checkboxField_input:indeterminate ~ div[role='presentation'] {
  border: none;
  box-shadow: none;
  background-color: var(--colors-primary-main);
}
